import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import SikerLogo from 'assets/images/relifCompanies/primary-siker-logo.webp';
import ZellerLogo from 'assets/images/relifCompanies/primary-zeller-logo.webp';
import { PrimaryBtn } from 'components/UI/Buttons';
import useIsInsurance from 'hooks/useIsInsurance';

import NavigationTopBar from './NavigationTopBar';

const BlueSeparator = () => (
  <svg
    width="80%"
    preserveAspectRatio="none"
    height="2"
    viewBox="0 0 180 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 1.00003L180 1.00005" stroke="#DCB705" strokeWidth="2" />
  </svg>
);

const Navigation = () => {
  const navigate = useNavigate();
  const isInsurance = useIsInsurance();
  const [openMenu, setOpenMenu] = useState(false);

  const renderMobileNavigationLinks = () => (
    <>
      <Button
        variant="text"
        onClick={() => {
          navigate('/casos-de-exito');
          setOpenMenu(false);
        }}
        sx={{
          fontFamily: 'Roboto',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '24px',
          color: 'black',
        }}
      >
        Casos de éxito
      </Button>
      <BlueSeparator />
      <Button
        variant="text"
        onClick={() => {
          navigate('/quienes-somos');
          setOpenMenu(false);
        }}
        sx={{
          fontFamily: 'Roboto',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '24px',
          color: 'black',
        }}
      >
        Quiénes somos
      </Button>
    </>
  );

  return (
    <AppBar
      sx={{
        variant: 'h2',
        backgroundColor: 'white',
        boxShadow: 'none',
      }}
    >
      <Box sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.15)' }}>
        <NavigationTopBar />
      </Box>
      <Container>
        <Box my={0.5} display="flex" justifyContent="space-between" alignItems="center" sx={{ mx: 'auto' }}>
          <Box sx={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            <img
              src={isInsurance ? SikerLogo : ZellerLogo}
              alt="Logo"
              style={{
                maxWidth: isInsurance ? '120px' : '150px',
              }}
            />
          </Box>

          <Box display={{ xs: 'none', md: 'flex' }} alignItems="center" gap={3}>
            <Button
              variant="text"
              onClick={() => navigate('/casos-de-exito')}
              sx={{
                color: 'black',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: '#DCB705',
                },
              }}
            >
              Casos de éxito
            </Button>
            <Button
              variant="text"
              onClick={() => navigate('/quienes-somos')}
              sx={{
                color: 'black',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: '#DCB705',
                },
              }}
            >
              Quiénes somos
            </Button>
            <PrimaryBtn
              variant="outlined"
              sx={{
                color: 'black',
                backgroundColor: '#F9D00A',
                borderColor: '#F9D00A',
                '&:hover': {
                  backgroundColor: '#DCB705',
                  borderColor: '#DCB705',
                  color: 'black',
                  transform: 'translateY(-1px)',
                },
                transition: 'all 0.2s ease-in-out',
              }}
              onClick={() => navigate('/sign-in')}
            >
              Iniciar sesión
            </PrimaryBtn>
          </Box>

          <Box display={{ xs: 'flex', md: 'none' }}>
            <IconButton onClick={() => setOpenMenu(true)} sx={{ p: 1 }}>
              <MenuIcon sx={{ color: 'black', fontSize: '28px' }} />
            </IconButton>

            <SwipeableDrawer
              open={openMenu}
              onClose={() => setOpenMenu(false)}
              onOpen={() => setOpenMenu(true)}
              anchor="right"
              sx={{
                '& .MuiDrawer-paper': {
                  width: 280,
                  backgroundColor: 'white',
                },
              }}
            >
              <Stack spacing={3} alignItems="center" py={6} px={3}>
                <Box mb={2}>
                  <img
                    src={isInsurance ? SikerLogo : ZellerLogo}
                    alt="Logo"
                    style={{
                      maxWidth: isInsurance ? '100px' : '120px',
                    }}
                  />
                </Box>

                {renderMobileNavigationLinks()}

                <BlueSeparator />

                <PrimaryBtn
                  variant="outlined"
                  sx={{
                    color: 'black',
                    backgroundColor: '#F9D00A',
                    borderColor: '#F9D00A',
                    fontWeight: 600,
                    px: 4,
                    py: 1,

                    width: '100%',
                    maxWidth: '200px',
                    '&:hover': {
                      backgroundColor: '#DCB705',
                      borderColor: '#DCB705',
                      color: 'black',
                    },
                  }}
                  onClick={() => {
                    navigate('/sign-in');
                    setOpenMenu(false);
                  }}
                >
                  Iniciar sesión
                </PrimaryBtn>
              </Stack>
            </SwipeableDrawer>
          </Box>
        </Box>
      </Container>
    </AppBar>
  );
};

export default Navigation;
